<!--
 * @Author: zl
 * @Date: 2022-09-01 11:11:06
 * @LastEditTime: 2022-11-10 09:46:04
 * @LastEditors: zl
 * @Description: 项目资料
-->
<template>
	<div class='projectData-layout'>
		<div class="text-right btnGroups mb10">
			<el-select placeholder="请选择"
					   v-model="curLevel"
					   @change="changeLevel"
					   size="small">
				<el-option v-for="n in maxLevel"
						   :key="'level' + n"
						   :value="n"
						   :label="`展开到${n}级`"></el-option>
			</el-select>
		</div>
		<vxe-table ref="dataTable"
				   :data="dataTableObj.tableData"
				   resizable
				   border
				   :loading="dataTableObj.loading"
				   row-id="templateId"
				   height="90%"
				   :tree-config="{children: 'children'}"
				   show-overflow
				   show-header-overflow>
			<vxe-table-column title="序号"
							  align="left"
							  width="80"
							  type="seq"></vxe-table-column>
			<vxe-table-column title="资料清单"
							  field="sname"
							  align="left"
							  tree-node
							  min-width="300">
				<template #default="{ row }">
					<el-tooltip effect="dark"
								:content="row.remark"
								:disabled="[0, 1].includes(row.level) || !row.remark"
								placement="top">
						<span>{{ row.sname }}</span>
					</el-tooltip>
				</template>
			</vxe-table-column>
			<vxe-table-column title="附件"
							  field="fileName"
							  align="center"
							  min-width="200">
				<template #default="{ row }">
					<span class="vxe-table--cell blue-text"
						  v-if="row.fileList.length > 0"
						  @click="addData(row, 'view')">
						查看（共{{ row.fileList.length }} 个文件）
					</span>
					<span v-else>-</span>
				</template>
			</vxe-table-column>
			<vxe-table-column field="upFlag"
							  title="是否需要上传"
							  align="center"
							  width="150">
				<template #default="{ row }">
					<div v-if="[2, 3].includes(row.level)">
						{{ row.upFlag === 1 ? '是' : '否' }}
					</div>
					<div v-else>-</div>
				</template>
			</vxe-table-column>
			<vxe-table-column title="操作"
							  align="center"
							  width="250">
				<template #default="{ row }">
					<el-button size="small"
							   type="primary"
							   class="table-btn mr10"
							   round
							   plain
							   v-if="row.upFlag === 1"
							   icon="el-icon-upload2"
							   :disabled="row.noSuchContent === 1"
							   @click="addData(row, 'add')">上传
					</el-button>
					<el-checkbox v-if="[2, 3].includes(row.level)"
								 :disabled="row.fileList.length > 0"
								 v-model="row.noSuchContent"
								 :true-label="1"
								 :false-label="0"
								 @change="contentChange(row)">暂无此内容</el-checkbox>
				</template>
			</vxe-table-column>
		</vxe-table>

		<!-- 新增/查看附件 -->
		<el-dialog title="附件"
				   :visible.sync="dialog.show"
				   :close-on-click-modal="false"
				   width="1200px"
				   :before-close="dialogClose">
			<p class="mb10 mt10"
			   v-if="dialog.type == 'add'">
				请将需要上传的文件在此窗口一次性操作完毕，窗口关闭后之前上传的文件将会被覆盖
			</p>
			<tableUpload v-if="dialog.show"
						 ref="tableUpload"
						 tableName="bus_project_file"
						 assortment="bus_project_file"
						 :mode="dialog.type"
						 :aid="dataTableObj.currentId"
						 :maxNum="100"></tableUpload>
			<div slot="footer"
				 class="text-center"
				 v-if="dialog.type === 'add'">
				<el-button @click="dialogClose"
						   size="small">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="dialog.loading"
						   @click="doUpload">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import * as API from '@/api/modules/projectData'
import tableUpload from '@/components/upload/tableUpload'
export default {
	props: {},
	components: { tableUpload },
	data() {
		return {
			curLevel: 1,
			maxLevel: 1, // 最大level
			dataTableObj: {
				tableData: [], // 表格数据
				currentId: '',
				loading: false,
				curTemplateId: '',
			},
			dialog: {
				type: 'add',
				show: false,
				loading: false,
			},
		}
	},
	created() {
		// 根据项目ID 回显附件
		this.getDataFiles(this.curProjectId)
	},
	mounted() {},
	methods: {
		// 根据项目ID 回显附件
		getDataFiles(aid) {
			let that = this
			this.dataTableObj.loading = true
			API.getProjectFileData({
				projectId: aid || '',
				tableName: '',
			})
				.then((res) => {
					this.dataTableObj.tableData = res.data
					this.maxLevel =
						res.data[0] && res.data[0].maxLevel
							? parseInt(res.data[0].maxLevel) + 1
							: 1
					this.curLevel = this.maxLevel

					setTimeout(() => {
						that.$refs.dataTable
							? that.$refs.dataTable.setAllTreeExpand(true)
							: ''
						this.dataTableObj.loading = false
					}, 500)

					// 主键ID
					if (
						this.dataTableObj.curTemplateId &&
						this.dataTableObj.curTemplateId !== ''
					) {
						let _item = this.$utils.findTree(
							res.data,
							(x) =>
								x.templateId === this.dataTableObj.curTemplateId
						)
						_item
							? (this.dataTableObj.currentId = _item.item.id)
							: ''
					}
				})
				.catch((err) => {
					this.dataTableObj.tableData = []
					this.dataTableObj.loading = false
				})
		},

		// 切换展开层级
		changeLevel(level) {
			// 先关闭所有
			this.$refs.dataTable.clearTreeExpand()

			// 找到对应层级的数组
			let arr = this.$utils.filterTree(
				this.dataTableObj.tableData,
				(x) => x.level < level - 1
			)
			this.$refs.dataTable.setTreeExpand(arr, true)
		},

		// 弹窗点击
		addData(data, type) {
			this.dataTableObj.currentId = data.id
			this.dialog.show = true
			this.dialog.type = type
		},

		// 弹窗关闭
		dialogClose() {
			this.dialog.loading = false
			this.dialog.show = false
			this.dialog.type = 'add'
			this.dataTableObj.currentId = ''
			this.getDataFiles(this.curProjectId)
		},

		// 确认上传
		doUpload() {
			this.dialog.loading = true
			this.$refs.tableUpload.fileSend(
				this.dataTableObj.currentId,
				this.curProjectId,
				() => {
					this.dialogClose()
				},
				() => {
					this.dialog.loading = false
				}
			)
		},

		// 暂无此内容
		contentChange(data) {
			API.updateProjectFileNodeState({
				noSuchContent: data.noSuchContent ? 1 : 0,
				id: data.id,
			}).then((res) => {})
		},
	},
	computed: {
		// 当前项目ID
		curProjectId() {
			return this.$route.query.projectId
		},
	},
}
</script>

<style lang='less' scoped>
.projectData-layout {
	overflow-y: auto;
	height: 100%;
	padding: 20px 10px;
	@btnColorPrimary: #60adf9;
	.blue-text {
		color: @btnColorPrimary;
		cursor: pointer;
	}
}
</style>